import React from "react";
import styled from "@emotion/styled";
import { css } from "@emotion/react";
import SmallButton from "@ats/src/components/shared/SmallButton";
import breakpoint from "@shared/styles/breakpoints";

const ContactUsCallout: React.FC = () => {
  return (
    <Styled.Container>
      <Styled.Content>
        <Styled.Title>Need additional jobs?</Styled.Title>
        <Styled.Body>
          Contact us at contact@polymer.co and we'll set you up with a custom plan.
        </Styled.Body>
      </Styled.Content>

        <Styled.Button
          styleType="white"
          onClick={() => window.open("mailto:contact@polymer.co", "_blank")}
        >
          Contact Us
        </Styled.Button>

    </Styled.Container>
  );
};

export default ContactUsCallout;

/* Styled Components
======================================================= */
let Styled: any;
Styled = {};

Styled.Container = styled.div((props) => {
  const t: any = props.theme;
  return css`
    label: ContactUsCallout_Container;
    width: 100%;
    ${[t.mt(3), t.p(5), t.rounded.md]}
    background: ${t.dark ? t.color.gray[800] : t.color.gray[100]};
    border: 1px solid ${t.dark ? t.color.gray[800] : t.color.gray[100]};
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    flex-direction: column;

    ${breakpoint.xs} {
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
    }
  `;
});

Styled.Content = styled.div((props) => {
  const t: any = props.theme;
  return css`
    label: ContactUsCallout_Content;
    width: 100%;
  `;
});

Styled.Title = styled.h3((props) => {
  const t: any = props.theme;
  return css`
    label: ContactUsCallout_Title;
    ${[t.mb(2)]}
    font-size: 1rem;
    color: ${t.dark ? t.color.gray[200] : t.color.black};
    font-weight: 500;
    line-height: 1.4;

    ${breakpoint.xs} {
      ${t.mb(1)};
      font-size: 0.875rem;
    }
  `;
});

Styled.Body = styled.p((props) => {
  const t: any = props.theme;
  return css`
    label: ContactUsCallout_Body;
    ${[t.text.xs]}
    color: ${t.dark ? t.color.gray[300] : t.color.gray[600]};
    line-height: 1.2;
    max-width: 300px;

    @media (min-width: 1100px) {
      max-width: 100%;
    }
  `;
});

Styled.CTA = styled.div((props) => {
  const t: any = props.theme;
  return css`
    label: ContactUsCallout_CTA;

  `;
});

Styled.Button = styled(SmallButton)((props) => {
  const t: any = props.theme;
  return css`
    label: ContactUsCallout_Button;
    border: 1px solid ${t.color.gray[200]};
    ${t.mt(6)};
    width: 100%;

    ${breakpoint.xs} {
      ${t.mt(0)};
    }
  `;
});
